import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  background: radial-gradient(circle, pink, purple);
  position: relative;
  display: flex;
`;

export const Inner = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: 1fr 100px;
  grid-template-columns: 1fr 300px;
  gap: 10px;
  flex: 1;
`;

export const Main = styled.div`
  position: relative;
  display: flex;
`;

export const Side = styled.div`
  position: relative;
  display: flex;
  padding: 10px;
  flex-direction: column;
  padding-top: 30px;
`;

export const Play = styled.div`
  position: absolute;
  top: -44px;
  left: 50%;
  transform: translateX(-50%);
`;

export const Seek = styled.div`
  position: absolute;
  top: -13px;
  left: 0;
  right: 0;
  display: flex;
  margin-left: 30px;
`;

export const Timeline = styled.div`
  position: relative;
  margin-left: 20px;
`;

export const Extra = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Overlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: 999999;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  pointer-events: none;
`;

export const Info = styled.div`
  height: 30px;
  color: #333;
  border-radius: 5px;
  width: 180px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Controls = styled.div`
  background-color: rgba(0, 0, 0, 9);
  color: #333;
  border-radius: 5px;
`;
